import {
  TaskStatus,
  taskStatusSchema,
} from '@/task-manager/entities/task-status';

export function taskStatusMapper(data: string): TaskStatus {
  return taskStatusSchema.parse(data);
}
